/* eslint-disable jsx-a11y/anchor-is-valid */
// Dependencies
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// images

import logo from '../../sass/images/logo_navbar.png';
import icono1 from '../../sass/images/icons/scheduling_icon_white.svg';
import icono2 from '../../sass/images/icons/icono-historial-white.svg';
import icono3 from '../../sass/images/icons/icono-awesome-handshake.svg';
import icono4 from '../../sass/images/menuMovil/icon_ionic_ios_document.svg';
import icono5 from '../../sass/images/menuMovil/icon_feather_book_open.svg';
import perfil from '../../sass/images/img-usuario-perfil.svg';
import closeWhite from '../../sass/images/icons/icon_exit_white.svg';
import alertMenu from '../../sass/images/icons/alert-mobile.svg';
import userWhite from '../../sass/images/icons/user_white.svg';
import inventoryWhite from '../../sass/images/icons/inventory_white.svg';

// Hooks
import useLanguage from '../hooks/useLanguage';
import useTermsAndConditions from '../hooks/useTermsAndConditions';
import useToggleMenu from '../hooks/useToggleMenu';
import useLogin from '../hooks/useLogin';

function InternalMenu(props) {
  const { t, newMaintenances } = props;
  const { handleChangeToggle } = useToggleMenu();
  const { isEnglish, changeLanguage, locale } = useLanguage();
  const { termAndCondition, termPoliticsPrivate } = useTermsAndConditions();
  const { rolId, logout } = useLogin({});

  return (
    <Navbar
      className="navBarMenu internal-content"
      expand="lg"
      onToggle={(toggle) => handleChangeToggle(toggle)}
    >
      <Link to={`/${locale}/${t('routers:WorkshopDashboard')}`}>
        <img src={logo} className="logoMenu" alt={t('alt:logo')} />
      </Link>
      <Nav className="mr-auto mobile">
        <Link
          to={`/${locale}/${t('routers:WorkshopDashboard')}`}
          className={` mobile login-images ${
            newMaintenances > 0 ? 'perfil-notification-movil' : ''
          }`}
        >
          <img src={perfil} alt={t('alt:perfil_workshop')} />
        </Link>
      </Nav>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="company-menu">
        <Nav className="mr-auto">
          <Link to={`/${locale}/${t('routers:Benefits')}`} className="desktop loginButton">
            {t('benefits')}
          </Link>
          <Link
            to={`/${locale}/${t('routers:WorkshopDashboard')}`}
            className={` desktop perfil_button ${newMaintenances > 0 ? 'perfil-notification' : ''}`}
          >
            <img src={perfil} alt={t('alt:perfil_workshop')} />
          </Link>
          <button
            type="button"
            onClick={() => {
              changeLanguage('en');
            }}
            className={
              isEnglish ? 'desktop leguajeButton langEn' : 'desktop leguajeButton langEnOff'
            }
          >
            Eng
          </button>

          <button
            type="button"
            onClick={() => {
              changeLanguage('es');
            }}
            className={
              !isEnglish
                ? 'desktop leguajeButton second langEs'
                : 'desktop leguajeButton second langEsOff'
            }
          >
            Esp
          </button>
          {/* MOVIL */}
          <div className="button_language">
            <button
              type="button"
              onClick={() => {
                changeLanguage('en');
              }}
              className={
                isEnglish ? 'mobile leguajeButton langEn' : 'mobile leguajeButton langEnOff'
              }
            >
              Eng
            </button>

            <button
              type="button"
              onClick={() => {
                changeLanguage('es');
              }}
              className={
                !isEnglish
                  ? 'mobile leguajeButton second langEs'
                  : 'mobile leguajeButton second langEsOff'
              }
            >
              Esp
            </button>
          </div>
          <div className="mobilecontent internal">
            <Link to={`${t('routers:MaintenanceSchedule')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono1} alt={t('alt:maintenance_schedule')} />
              </span>
              <span className="textmenumobile">
                {t('privateMenu:maintenance-schedule')}
                {newMaintenances > 0 ? (
                  <img
                    className="img-alert-menu mobile-icon"
                    src={alertMenu}
                    alt={t('alt:notification')}
                  />
                ) : (
                  ''
                )}
              </span>
            </Link>
            <Link to={`${t('routers:MaintenanceHistory')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono2} alt={t('alt:maintenance_history')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:maintenance-history')}</span>
            </Link>
            {rolId === 4 ? (
              <Link to={`${t('routers:UserRegistrationWorkShop')}`} className="mobile x2">
                <span className="iconmenumobile">
                  <img src={userWhite} alt={t('alt:user_registration')} />
                </span>
                <span className="textmenumobile">{t('privateMenu:userRegistration')}</span>
              </Link>
            ) : (
              ''
            )}
            <Link to={`${t('routers:StockStorage')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={inventoryWhite} alt={t('alt:storage')} />
              </span>
              <span className="textmenumobile">{t('privateMenu:stockStorage')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:Benefits')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono3} alt={t('alt:benefits')} />
              </span>
              <span className="textmenumobile">{t('benefits')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termAndCondition.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono4} alt={t('alt:termAndCondition')} />
              </span>
              <span className="textmenumobile">{t('menu:terms-condition')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termPoliticsPrivate.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono5} alt={t('alt:authorizationData')} />
              </span>
              <span className="textmenumobile border-none">{t('menu:terms-data')}</span>
            </Link>
            <Link to="" onClick={logout} className="mobile x2 close_mobile">
              <span className="iconmenumobile">
                <img src={closeWhite} alt={t('alt:logout')} />
              </span>
              <span className="textmenumobile">{t('menu:logout')}</span>
            </Link>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

InternalMenu.propTypes = {
  t: PropTypes.func.isRequired,
  newMaintenances: PropTypes.number,
};

InternalMenu.defaultProps = {
  newMaintenances: 0,
};

export default withTranslation(['internalMenu', 'routers', 'menu', 'privateMenu', 'alt'])(
  InternalMenu
);
